import BrandAdditionalInfo from "./BrandAdditionalInfo";

export default BrandAdditionalInfo;
